import React from 'react';
import {StyleSheet, Text, TouchableOpacity, View} from 'react-native';
import {FONTS, TYPE} from 'style/typography';

/**
 * After a quiet minute in tutor mode (nobody talking or typing) the player asks if the learner is still there; with no
 * answer in 15 s tutor mode closes so it stops using their minutes (Sol tutor-idle C; same card as the iPhone app).
 */
export default function TutorIdleCard({onKeepTalking}) {
  return (
    <View style={styles.anchor} pointerEvents="box-none">
      <View style={styles.card} accessibilityRole="alert">
        <Text style={styles.title}>Still there?</Text>
        <TouchableOpacity style={styles.button} onPress={onKeepTalking} accessibilityRole="button" testID="tutor-keep-talking">
          <Text style={styles.buttonText}>Keep Talking</Text>
        </TouchableOpacity>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  anchor: {position: 'absolute', left: 0, right: 0, top: '32%', alignItems: 'center', zIndex: 60},
  card: {
    minWidth: 260,
    paddingVertical: 24,
    paddingHorizontal: 24,
    borderRadius: 16,
    backgroundColor: 'rgba(15,16,20,0.94)',
    borderWidth: 1,
    borderColor: 'rgba(197,232,54,0.45)',
    alignItems: 'center',
  },
  title: {fontFamily: FONTS.body, color: '#F6FBFF', fontSize: TYPE.xl, lineHeight: 28, fontWeight: '700'},
  button: {
    marginTop: 16,
    minHeight: 48,
    paddingHorizontal: 24,
    borderRadius: 12,
    backgroundColor: '#C5E836',
    alignItems: 'center',
    justifyContent: 'center',
  },
  buttonText: {fontFamily: FONTS.body, color: '#0B0B0C', fontSize: TYPE.base, fontWeight: '700'},
});
